/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { jsx } from '@atlaskit/css';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { agentAvatarCache } from './agent-avatar-cache';

type PromptAgentAvatarProps = {
	agent: Agent;
};

export const PromptAgentAvatar = ({ agent }: PromptAgentAvatarProps): JSX.Element => {
	// The mention row already has this picture. Prefer it over the generated
	// or Forge icon so the selector matches the row the user just chose,
	// including before agent details finish loading.
	const mentionAvatarUrl = agentAvatarCache.get(agent.id);

	return (
		<AgentAvatar
			imageUrl={mentionAvatarUrl}
			agentNamedId={agent.external_config_reference ?? agent.named_id}
			agentId={agent.id}
			agentIdentityAccountId={agent.identity_account_id}
			size="small"
			showBorder={false}
			isForgeAgent={agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE'}
			forgeAgentIconUrl={mentionAvatarUrl ? undefined : agent.icon}
		/>
	);
};
